import { Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import get from "lodash.get";

export const distinctUntilPropsChange = (propNames: string[] = []) => <T>(source: Observable<T>): Observable<T> =>
    source.pipe(
        distinctUntilChanged<T>((prev, current) => propNames.reduce((acc, prop) => acc && get(prev, prop) === get(current, prop), true))
    );
